export const Verify = [
  { text: "Kode Barang", value: "sku", sortable: false },
  { text: "Nama Produk", value: "name", sortable: false },
  { text: "Cabang", value: "branch_name", sortable: false },
  { text: "Sub Cabang", value: "sub_branch_name", sortable: false },
  { text: "Catatan", value: "note", sortable: false },
  { text: "Status", value: "status", sortable: false },
  { text: "Detail", value: "detail", sortable: false },
];
